import Vue from 'vue'
import orderManageApi from '@/api/orderManage/api.order'



// import '../../Mock/orderManageMock'


const SETEXPRESSLIST = 'SETEXPRESSLIST'

export default {
	state: {
		expressList:[]

	},
	actions: {
		getExpressList({commit},params){
			orderManageApi.getExpressList(params,function(res){
				commit('SETEXPRESSLIST',res.body.data)
			})
		}
	},
	mutations:{
		SETEXPRESSLIST(state,data){
			state.expressList = data
		}
	}
}


// WEBPACK FOOTER //
// ./src/js/store/orderExpressState.js